module.exports = __webpack_public_path__ + "static/media/author.0f0a3231.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/author.svg
// module id = 204
// module chunks = 17